<template>
	<div>
		<v-sheet rounded class="mb-4">
			<v-card color="#125B92" elevation="0" class="rounded-b-0">
				<v-card-title class="align-center">
					<v-icon left large color="#E3ECF2">mdi-folder</v-icon>
					<h3 class="white--text">{{ title }}</h3>
					<v-spacer />
					<slot />
				</v-card-title>

				<v-divider />

				<v-data-table
					v-model="selected"
					:headers="tableHeaders"
					:items="files"
					:loading="loading"
					:search="search"
					show-select
					items-per-page.sync="30"
					:footer-props="{
						'items-per-page-options': [10, 20, 30, 40, 50]
					}"
					class="table-stripped"
					@update:page="$vuetify.goTo(0)">
					<template #top>
						<v-toolbar flat>
							<delete-button :small="false"
								:disabled="! length(selected)"
								model="files"
								:model-ids="selectedIds"
								:only="['files', 'counts', 'flash']"
								@deleted="selected = []">
								Delete Selected <span v-if="length(selected)" class="ml-1">({{ length(selected) }})</span>
							</delete-button>
							<v-spacer />
							<div class="flex-fill datatable-filter-large">
								<v-text-field
									v-model="search"
									class="table-search"
									append-icon="mdi-magnify"
									placeholder="Search..."
									name="search"
									autocomplete="off"
									single-line
									clearable
									filled
									outlined
									dense
									full-width
									autofocus
									hide-details />
							</div>
							<div class="ml-3">
								<v-chip>{{ length(files) | numeric }}</v-chip>
							</div>
						</v-toolbar>
						<v-divider />
					</template>

					<template #item.name="{ item }">
						<div class="mb-1">
							<a v-if="item.in_storage" href="#" @click.prevent="previewingFile = item">{{ item.name }}</a>
							<span v-else>{{ item.name }}</span>
						</div>
						<v-chip v-if="! item.in_storage" small label color="red lighten-4">deleted</v-chip>
						<v-chip small label>{{ item.size | prettyBytes }}</v-chip>
						<v-chip small label>{{ item.type }}</v-chip>
					</template>

					<template #item.created_at="{ item }">
						{{ item.created_at | localDateTime }}
					</template>

					<template #item.creator="{ item }">
						{{ item.creator.name }}
					</template>

					<template #item.actions="{ item }">
						<v-btn
							:href="route('files.show', item)"
							:disabled="! item.in_storage"
							target="_blank"
							color="green darken-2"
							elevation="0"
							icon
							outlined
							class="py-2 px-4 text-decoration-none">
							<v-icon>mdi-download</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-card>
		</v-sheet>

		<file-preview :file="previewingFile" @close="previewingFile = null" />
	</div>
</template>
<script>
import DeleteButton from '@/Pages/Backend/Components/DeleteButton'
import FilePreview from '@/Pages/Backend/Files/Preview.vue'

export default {
	components: { DeleteButton, FilePreview },
	props: {
		title: {
			type: String,
			default: 'Files'
		},
		files: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			previewingFile: null,
			search: '',
			statuses: [],
			loading: false,
			selected: [],
			tableHeaders: [
				{
					text: 'File Name',
					sortable: false,
					align: 'start',
					value: 'name'
				},
				{
					text: 'Uploaded By',
					sortable: false,
					align: 'start',
					value: 'creator'
				},
				{
					text: 'Uploaded',
					sortable: false,
					align: 'start',
					value: 'created_at'
				},
				{
					text: '',
					sortable: false,
					align: 'end',
					value: 'actions'
				}
			]
		}
	},
	computed: {
		selectedIds () {
			return this.selected.map(file => file.id)
		}
	},
	watch: {
		//
	},
	mounted () {
		//
	},
	methods: {
		//
	}
}
</script>
